import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/common.service';
import { TenderList, TenderCard } from 'tender-api';
import { GetTenderStatusDescription, GetTenderCategoryByCode } from '../utils/tender-utils';
import * as moment from 'moment/moment';


@Component({
  selector: 'app-tenders',
  templateUrl: './tenders.component.html',
  styleUrls: ['./tenders.component.css']
})
export class TendersComponent implements OnInit {

  @Input('isParticipations') isParticipations: boolean;

  pageSize: number = 10;
  pageNumber: number = 0;
  currentStatuses: string = "DRAFT,ONGOING,DISCOUNT,DEAL";
  currentCards: Array<TenderCard> = [];
  closedCards: Array<TenderCard> = [];
  showMore: boolean = true;
  isHistoryView: boolean = false;
  goToClosedLinkLabel: string = "VAI ALLO STORICO GARE CHIUSE";
  backLinkLabel: string = "TORNA ALLE GARE IN CORSO";
  emptyLabel: string = "";
  showMoreLabel: string = "ALTRE GARE";

  constructor(
    private commonService: CommonService,
    private router: Router
  ) { }

  ngOnInit(): void {
    window['moment'] = moment;
    if (this.isParticipations) {
      this.goToClosedLinkLabel = "VAI ALLO STORICO PARTECIPAZIONI CHIUSE";
      this.backLinkLabel = "TORNA ALLE PARTECIPAZIONI IN CORSO";
      this.showMoreLabel = "ALTRE PARTECIPAZIONI";
    }

    this.loadCurrent();
  }

  loadCurrent() {
    this.pageNumber = 0;
    this.loadCurrentList();
  }

  loadClosed() {
    this.pageNumber = 0;
    this.loadClosedList();
  }

  loadCurrentList() {
    this.isHistoryView = false;
    this.closedCards = [];
    if (!this.isParticipations) {
      this.commonService.getTenderService().tenderGet(
        this.pageSize,
        this.pageNumber,
        this.currentStatuses
      ).subscribe(
        (res: TenderList) => {
          console.log('Current tenders : ' + JSON.stringify(res));

          this.currentCards =  this.currentCards.concat(res.tenders);

          this.showMore = res.paging.pageNumber < (res.paging.totalPages - 1);
          this.closedCards = [];
          this.emptyLabel = "Nessuna gara presente";
        },
        error => {
          console.error(error);
        }
      );
    } else {
      this.commonService.getParticipationService().tenderParticipationGet(
        this.pageSize,
        this.pageNumber,
        this.currentStatuses
      ).subscribe(
        (res: TenderList) => {
          console.log('Current participations: ' + res);

          this.currentCards =  this.currentCards.concat(res.tenders);

          this.showMore = res.paging.pageNumber < (res.paging.totalPages - 1);
          this.closedCards = [];
          this.emptyLabel = "Nessuna partecipazione presente";
        },
        error => {
          console.error(error);
        }
      );
    }

  }

  getCategoryName(categoryCode: string) {
    return GetTenderCategoryByCode(categoryCode).description;
  }

  getStatusDesciption(statusCode: string) {
    return GetTenderStatusDescription(statusCode);
  }

  getFormattedDate(date: string) {
    return moment(date).format('DD-MM-YYYY');
  }

  loadMore() {
    this.pageNumber = this.pageNumber + 1;
    if (this.isHistoryView) {
      this.loadClosedList();
    } else {
      this.loadCurrentList();
    }
  }

  goToDetail(card: TenderCard) {
    if (this.isParticipations) {
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'participationDetail', "tenderId": card.tenderId, "bestOffer" : card.bestOffer } });
       // window.open('/areariservata?tabToLoad=participationDetail&tenderId=' + tenderId, '_self');
    } else {
        this.router.navigate(['/areariservata'], { queryParams: { "tabToLoad": 'tenderDetail', "tenderId": card.tenderId } });
      //window.open('/areariservata?tabToLoad=tenderDetail&tenderId=' + tenderId, '_self');
    }
  }

  isDetailVisible(statusCode: string) {
      return true;
    //return statusCode === 'DRAFT' || statusCode === 'ONGOING' || statusCode === 'DISCOUNT' || statusCode === 'DEAL' || statusCode === 'ACCEPTED';
  }

  loadClosedList() {
    this.currentCards = [];
    this.isHistoryView = true;
    let closedStatuses = "ACCEPTED,REFUSED,ABORTED";

    if (!this.isParticipations) {
      this.commonService.getTenderService().tenderGet(
        this.pageSize,
        this.pageNumber,
        closedStatuses
      ).subscribe(
        (res: TenderList) => {
          console.log('Current tenders: ' + JSON.stringify(res));
          this.closedCards =  this.closedCards.concat(res.tenders);
          this.showMore = res.paging.pageNumber < (res.paging.totalPages - 1);
          this.emptyLabel = "Nessuna gara presente";
        },
        error => {
          console.error(error);
        }
      );
    } else {
      this.commonService.getParticipationService().tenderParticipationGet(
        this.pageSize,
        this.pageNumber,
        closedStatuses
      ).subscribe(
        (res: TenderList) => {
          console.log('Current tenders: ' + res);
          this.closedCards =  this.closedCards.concat(res.tenders);
          this.showMore = res.paging.pageNumber < (res.paging.totalPages - 1);
          this.emptyLabel = "Nessuna partecipazione presente";
        },
        error => {
          console.error(error);
        }
      );
    }


  }

}
